<template>
  <div class="space-y-2">
    <p>
      In addition to cookies, we use browser local storage to improve user experience.
    </p>
    <p>
      Local storage is used to save non-personal site preferences, such as:
    </p>
    <ul class="list-disc list-inside space-y-1">
      <li>Theme or layout settings</li>
      <li>Display preferences</li>
      <li>Search or filter configurations</li>
    </ul>
    <p>
      Local storage data remains on your device and is never transmitted to our servers. You can clear it at any time by clearing your browser’s local storage or cache.
    </p>
  </div>
</template>
